// extracted by mini-css-extract-plugin
module.exports = {"map":"map-module--map--1H_uv","map__frame":"map-module--map__frame--D1-aE","mapTitle":"map-module--map-title--MbheY"};